import dayjs from "dayjs";
import i18n from "features/shared/i18n";
import { ParentPieceReport, ParentReportTarget } from "features/player/types";

/** 通報した相手の名前（ピース名 or アプリ名） */
export const reportTargetName = (report: ParentPieceReport) =>
  (report.target === ParentReportTarget.PROJECT ? report.project_name : report.piece_name) ?? "";

/** 通報した相手の種類の文言 */
export const reportTargetLabelKey = (target: ParentReportTarget) =>
  ({
    [ParentReportTarget.PIECE]: "MSG_PARENT_PAGE_PLAYER_REPORT_TARGET_PIECE",
    [ParentReportTarget.COMMENT]: "MSG_PARENT_PAGE_PLAYER_REPORT_TARGET_COMMENT",
    [ParentReportTarget.PROJECT]: "MSG_PARENT_PAGE_PLAYER_REPORT_TARGET_PROJECT",
  })[target];

/** 通報の理由。kids で子どもが選んだものと同じ並び */
export const reportReasonKey = (reason: string) =>
  ({
    inappropriate: "MSG_PARENT_PAGE_PLAYER_REPORT_REASON_INAPPROPRIATE",
    dislike_expression: "MSG_PARENT_PAGE_PLAYER_REPORT_REASON_DISLIKE",
    spam: "MSG_PARENT_PAGE_PLAYER_REPORT_REASON_SPAM",
    copyright: "MSG_PARENT_PAGE_PLAYER_REPORT_REASON_COPYRIGHT",
  })[reason] ?? "MSG_PARENT_PAGE_PLAYER_REPORT_REASON_OTHER";

/** 運営の対応状況 */
export const reportStatus = (status: string) =>
  ({
    pending: {
      labelKey: "MSG_PARENT_PAGE_PLAYER_REPORT_STATUS_PENDING",
      className: "bg-orange-100",
    },
    reviewed: {
      labelKey: "MSG_PARENT_PAGE_PLAYER_REPORT_STATUS_REVIEWED",
      className: "bg-blue-100",
    },
    dismissed: {
      labelKey: "MSG_PARENT_PAGE_PLAYER_REPORT_STATUS_DISMISSED",
      className: "bg-gray2-100",
    },
    actioned: {
      labelKey: "MSG_PARENT_PAGE_PLAYER_REPORT_STATUS_ACTIONED",
      className: "bg-green-100",
    },
  })[status] ?? {
    labelKey: "MSG_PARENT_PAGE_PLAYER_REPORT_STATUS_PENDING",
    className: "bg-orange-100",
  };

export const ParentPieceReportRow = ({
  report,
  onClick,
}: {
  report: ParentPieceReport;
  onClick?: () => void;
}) => {
  const status = reportStatus(report.status);

  return (
    <div
      onClick={onClick}
      className={`flex-col-el w-full gap-1 p-4 rounded-[12px] bg-gray2-20 box-border ${
        onClick ? "cursor-pointer hover:bg-gray2-30 transition-all" : ""
      }`}
    >
      <div className="flex-row-el items-center justify-between w-full gap-2">
        <div className="flex-row-el items-center gap-2 min-w-0">
          <span className="material-symbols-outlined text-[21px] text-red-100">flag</span>
          <span className="text-body text-body-ellipsis text-[21px] text-textcolor-black">
            {reportTargetName(report)}
          </span>
          <span className="text-[18px] text-gray2-100 shrink-0">
            {i18n.t(reportTargetLabelKey(report.target))}
          </span>
        </div>
        <span className="text-[18px] text-gray2-100 shrink-0">
          {dayjs(report.created_at).format("YYYY-MM-DD HH:mm")}
        </span>
      </div>

      <div className="flex-row-el items-center gap-2">
        <span
          className={`text-[18px] text-white px-3 py-1 rounded-full shrink-0 ${status.className}`}
        >
          {i18n.t(status.labelKey)}
        </span>
        <span className="text-[21px] text-textcolor-black">
          {i18n.t(reportReasonKey(report.reason))}
        </span>
      </div>
    </div>
  );
};
